import { keycloak } from "../..";
import { authServiceApi } from "../../app/authServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { toast } from "../../lib/toast";
import { CommonResponse } from "../../types";
import { TGetMeResponse } from "./auth.type";
import { setAuthInfo } from "./authSlice";

export const authApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<CommonResponse<TGetMeResponse>, void>({
      query: () => ({
        url: API_URL.getMe,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          const role = data?.data?.user?.role;

          if (role !== "organization_admin") {
            toast("error", "You are not allowed to log in to this system");
            setTimeout(async () => {
              await keycloak.logout();
              localStorage.clear();
            }, 500);

            return;
          }

          dispatch(setAuthInfo(data?.data?.user));
        } catch (err) {}
      },
      providesTags: () => [{ type: "GetMe" }],
    }),
    uploadFile: builder.mutation({
      query: (data) => {
        return {
          url: API_URL.uploadFile,
          method: "PATCH",
          body: data,
        };
      },
    }),
    uploadMobileToken: builder.mutation({
      query: (data) => {
        return {
          url: API_URL.uploadMobileToken,
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const {
  useGetMeQuery,
  useUploadMobileTokenMutation,
  useUploadFileMutation,
} = authApi;
